export default __webpack_public_path__ + "static/media/trophy-dynamic-gradient.0bb49d52.png";